import { LinkPrompt } from 'common/Prose/Prompts/LinkPrompt/LinkPrompt'
import { createPrompt } from 'common/Prose/Prompts/Prompt/Prompt'
import { applyLinkToSelection } from 'common/Prose/utils/link'
import { type EditorView } from 'prosemirror-view'
import { useCallback } from 'react'

export const useOpenLinkPrompt = (view: EditorView) => {
  return useCallback(() => {
    createPrompt({
      view,
      centered: true,
      mobileEnabled: true,
      prompt: (close) => {
        return (
          <LinkPrompt
            callback={({ link, text }) => {
              applyLinkToSelection(view, { link, text })
            }}
            close={close}
            initialText={''}
          />
        )
      },
    })
  }, [view])
}
